import * as React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { Overview } from '@app/Overview/Overview';
import { Screens } from '@app/Screens/Screens';
import { ScreenDetailPage } from '@app/Screens/ScreenDetailPage';
import { Campaigns } from '@app/Campaigns/Campaigns';
import { CampaignDetailPage } from '@app/Campaigns/CampaignDetailPage';
import { Moderation } from '@app/Moderation/Moderation';
import { Users } from '@app/Users/Users';
import { UserDetailPage } from '@app/Users/UserDetailPage';
import { Drivers } from '@app/Drivers/Drivers';
import { DriverDetailPage } from '@app/Drivers/DriverDetailPage';
import { Schedules } from '@app/Schedules/Schedules';
import { Billing } from '@app/Billing/Billing';
import { Settings } from '@app/Settings/Settings';
import { NotFound } from '@app/NotFound/NotFound';
import { useDocumentTitle } from '@app/utils/useDocumentTitle';

export interface IAppRoute {
  label?: string;
  component: React.ComponentType<any>;
  path: string;
  title: string;
}

const routes: IAppRoute[] = [
  { component: Overview, label: 'Overview', path: '/', title: 'Overview' },
  { component: Screens, label: 'Screens', path: '/screens', title: 'Screens' },
  { component: ScreenDetailPage, path: '/screens/:screenId', title: 'Screen Detail' },
  { component: Campaigns, label: 'Campaigns', path: '/campaigns', title: 'Campaigns' },
  { component: CampaignDetailPage, path: '/campaigns/:campaignId', title: 'Campaign Detail' },
  { component: Moderation, label: 'Moderation', path: '/moderation', title: 'Moderation' },
  { component: Users, label: 'Users', path: '/users', title: 'Users' },
  { component: UserDetailPage, path: '/users/:userId', title: 'User Detail' },
  { component: Drivers, label: 'Drivers', path: '/drivers', title: 'Drivers' },
  { component: DriverDetailPage, path: '/drivers/:driverId', title: 'Driver Detail' },
  { component: Schedules, label: 'Schedules', path: '/schedules', title: 'Schedules' },
  { component: Billing, label: 'Billing', path: '/billing', title: 'Billing' },
  { component: Settings, label: 'Settings', path: '/settings', title: 'Settings' }
];

const useScrollToTop = () => {
  const location = useLocation();
  const prev = useRef(location.pathname);
  useEffect(() => {
    if (prev.current !== location.pathname) {
      const container = document.getElementById('primary-app-container');
      if (container) container.scrollTo({ top: 0 });
      prev.current = location.pathname;
    }
  }, [location]);
};

const RouteWithTitle = ({ component: Component, title }: IAppRoute) => {
  useScrollToTop();
  useDocumentTitle(title);
  return <Component />;
};

const PageNotFound = ({ title }: { title: string }) => {
  useDocumentTitle(title);
  return <NotFound />;
};

const AppRoutes = () => (
  <Routes>
    {routes.map(({ path, component, title, label }, idx) => (
      <Route
        path={path}
        key={idx}
        element={<RouteWithTitle path={path} component={component} title={title} label={label} />}
      />
    ))}
    <Route path="*" element={<PageNotFound title="404 Page Not Found" />} />
  </Routes>
);

export { AppRoutes, routes };
